import React, { useMemo } from "react";
import EAModal from "../../../shared/Modal/EAModal";
import EAButton from "../../../shared/Buttons/EAButton";
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import { CourtGridCourt } from "../../../../models/CourtGridData";

interface IProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  availableCourts: CourtGridCourt[];
  selectedCourts: string[];
  setSelectedCourts: (courts: string[]) => void;
  updateCourtFilters?: (selectedCourts: string[], availableCourts: string[]) => void;
  persistentSelectedCourts?: string[];
  exerciseName?: string;
}

const CourtFiltersModal: React.FC<IProps> = ({
  open,
  setOpen,
  availableCourts,
  selectedCourts,
  setSelectedCourts,
  updateCourtFilters,
  persistentSelectedCourts = [],
  exerciseName,
}) => {
  // Sortowanie kortów w modalu
  const sortedAvailableCourts = useMemo(() => {
    if (!exerciseName || availableCourts.length === 0) return availableCourts;

    // Utwórz mapę z pozycjami kortów z exerciseName
    const courtOrderMap = new Map<string, number>();
    exerciseName
      .split(";")
      .map((name) => name.trim())
      .forEach((courtName, index) => {
        courtOrderMap.set(courtName, index);
      });

    // Sortuj korty na podstawie kolejności w mapie
    return [...availableCourts].sort((a, b) => {
      const orderA = courtOrderMap.has(a.courtName) ? courtOrderMap.get(a.courtName)! : 999;
      const orderB = courtOrderMap.has(b.courtName) ? courtOrderMap.get(b.courtName)! : 999;
      return orderA - orderB;
    });
  }, [availableCourts, exerciseName]);

  if (!availableCourts || availableCourts.length === 0) {
    return null;
  }

  const handleCourtToggle = (courtName: string) => {
    let newSelectedCourts;
    if (selectedCourts.includes(courtName)) {
      newSelectedCourts = selectedCourts.filter((court) => court !== courtName);
    } else {
      newSelectedCourts = [...selectedCourts, courtName];
    }

    // Używamy nowej metody, jeśli jest dostępna
    if (updateCourtFilters) {
      const allCourtNames = availableCourts.map((court) => court.courtName);
      updateCourtFilters(newSelectedCourts, allCourtNames);
    } else {
      setSelectedCourts(newSelectedCourts);
    }
  };

  return (
    <EAModal isOpen={open} hideButtons onClose={() => setOpen(false)} title="Filtry kortów">
      <>
        <p>Wybierz korty</p>
        <div className="SortModal">
          {sortedAvailableCourts.map((court) => (
            <EAButton
              key={court.courtName}
              onClick={() => handleCourtToggle(court.courtName)}
              title={court.courtName}
              startIcon={selectedCourts.includes(court.courtName) ? <MdCheckBox /> : <MdOutlineCheckBoxOutlineBlank />}
              variant="text"
              noMargins
            />
          ))}
        </div>
      </>
    </EAModal>
  );
};

export default CourtFiltersModal;
